import { render, staticRenderFns } from "./EvidenceModal.vue?vue&type=template&id=6e42c7f6&"
import script from "./EvidenceModal.vue?vue&type=script&lang=js&"
export * from "./EvidenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports